export default __webpack_public_path__ + "static/media/marvel-iron.b394df11.jpg";